var map = {
	"./annot-svg.svg": "9ec3",
	"./ccc-svg.svg": "91a6",
	"./choose file-svg.svg": "4fcc",
	"./choose folder-svg.svg": "2973",
	"./close.svg": "3736",
	"./dc-svg.svg": "4c49",
	"./de-svg.svg": "4382",
	"./dr_cl-svg.svg": "7053",
	"./electron-logo.svg": "b768",
	"./end-svg.svg": "b098",
	"./example.svg": "b7db",
	"./eye-open.svg": "2670",
	"./eye.svg": "7625",
	"./form.svg": "b8eb",
	"./logo.svg": "a2ff",
	"./mini.svg": "4d55",
	"./mix.svg": "6b54",
	"./myFiles.svg": "d5f3",
	"./nested.svg": "cf88",
	"./ora-svg.svg": "acf2",
	"./password.svg": "b65e",
	"./pause.svg": "bb4b",
	"./play-one.svg": "cc5c",
	"./qc-svg.svg": "2ed2",
	"./recycleBin.svg": "0d16",
	"./reduction.svg": "9586",
	"./start-svg.svg": "ec87",
	"./svg-svg.svg": "57ce",
	"./table.svg": "edd2",
	"./traj-svg.svg": "f9d3",
	"./transmission.svg": "90e4",
	"./tree.svg": "ac6c",
	"./user.svg": "3a06"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "a01f";